import { Component } from '@angular/core';

import { FirebaseService } from '../../services/firebase.service';

@Component({
  selector    : 'homepage',
  templateUrl : 'homepage.html',
  styleUrls   : [ 'homepage.scss' ]
})

export class HomepageComponent {
	constructor(
    private firebaseService : FirebaseService
  ) {}
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/homepage/homepage.ts